/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-underscore-dangle */
import { Container, Box, Typography } from '@mui/material';

const TermsAndConditionsOfUse = () => {
  return (
    <Container sx={{ px: 0, pb: 4 }}>
      <Typography variant="h6" fontWeight="bold" sx={{ mt: 6, mb: 2 }}>
        Terms and conditions of use
      </Typography>
      <Box
        sx={{
          px: 3,
          py: 3,
          backgroundColor: '#f5f5f5',
          borderRadius: 2,
          boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
          maxWidth: 1000,
          mx: 'auto',
          color: '#444',
          fontSize: '0.95rem',
          lineHeight: 1.8,
          textAlign: 'left',
        }}
      >
        {/* <Typography fontWeight="bold" gutterBottom>
          Terms and conditions of use
        </Typography> */}
        <Typography paragraph>Privacy Policy</Typography>

        <Typography paragraph>
          Privacy Statement for Digital Anarchy, Inc.
        </Typography>
        <Typography paragraph>
          Digital Anarchy, Inc. has created this privacy statement in order to
          demonstrate our firm commitment to privacy. The following discloses
          our information gathering and dissemination practices for this
          website: Digital Anarchy, Inc..
        </Typography>
        <Typography paragraph>
          We use your IP address to help diagnose problems with our server, and
          to administer our Web site. Your IP address is used to help identify
          you and your shopping cart and to gather broad demographic
          information.
        </Typography>
        <Typography paragraph>
          Our store (store.digitalanarchy.com) uses cookies to keep track of
          your shopping cart. We respect your privacy and do not share any
          information.
        </Typography>
        <Typography paragraph>
          This site contains links to other sites. Digital Anarchy, Inc. is not
          responsible for the privacy practices or the content of such Web
          sites.
        </Typography>
        <Typography paragraph>
          Digital Anarchy does not distribute or sell information collected by
          our store to any other 3rd party.
        </Typography>
        <Typography paragraph>Choice/Opt-Out</Typography>
        <Typography paragraph>
          Our site provides users the opportunity to opt-out of receiving
          communications from us at the point where we request information about
          the visitor.
        </Typography>
        <Typography paragraph>
          This site gives users the following options for removing their
          information from our database to not receive future communications or
          to no longer receive our service.
        </Typography>
        <Typography paragraph>
          You can send email to sales@digitalanarchy.com
        </Typography>
        <Typography paragraph>Contacting the Web Site</Typography>
        <Typography paragraph>
          If you have any questions about this privacy statement, the practices
          of this site, or your dealings with this Web site, you can contact
        </Typography>
        <Typography paragraph>
          Webmaster <br />
          Digital Anarchy, Inc.
          <br />
          226 Tulare St.
          <br />
          Brisbane, CA 94005
          <br />
          sales@digitalanarchy.com
        </Typography>
      </Box>
    </Container>
  );
};

export default TermsAndConditionsOfUse;
